import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getCatalogTranslations,
  postCatalogTranslation,
  putCatalogTranslation,
  deleteCatalogTranslation,
  postCatalogTranslationsRefreshCache,
} from 'services/api';
import { CatalogTranslationDto } from './interface';
import { CatalogName } from './catalogConstants';

export const getCatalogTranslationsAsync = createAsyncThunk(
  'catalogTranslations/getAll',
  async (catalogName?: CatalogName) => {
    const response = await getCatalogTranslations(catalogName);
    return response?.data;
  },
);

export const createCatalogTranslationAsync = createAsyncThunk(
  'catalogTranslations/create',
  async (dto: Omit<CatalogTranslationDto, 'id'>) => {
    const response = await postCatalogTranslation(dto);
    return response?.data;
  },
);

export const updateCatalogTranslationAsync = createAsyncThunk(
  'catalogTranslations/update',
  async ({ id, dto }: { id: string; dto: Omit<CatalogTranslationDto, 'id'> }) => {
    const response = await putCatalogTranslation(id, dto);
    return response?.data;
  },
);

export const deleteCatalogTranslationAsync = createAsyncThunk(
  'catalogTranslations/delete',
  async (id: string) => {
    const response = await deleteCatalogTranslation(id);
    return response?.data;
  },
);

export const refreshCatalogTranslationsCacheAsync = createAsyncThunk(
  'catalogTranslations/refreshCache',
  async () => {
    const response = await postCatalogTranslationsRefreshCache();
    return response?.data;
  },
);
